import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { Alert, Button, ButtonToolbar, Col, Row } from "components/bootstrap";
import { DocumentTitle, PageHeader, Spinner } from "components/common";
import AgentWorkflowDetails from "aiagent/AgentWorkflows/AgentWorkflowDetails";
import RunWorkflowButton from "aiagent/AgentWorkflows/RunWorkflowButton";
import useFeature from "hooks/useFeature";
import ModelProviderRequiredAlert from "aiagent/components/ModelProviderRequiredAlert";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import AgentWorkflowPageNavigation from "./AgentWorkflowPageNavigation";
import EditWorkflowConfigurationModal from "./AgentWorkflows/EditWorkflowConfigurationModal";
import useWorkflowDefinition from "./AgentWorkflows/hooks/useWorkflowDefinition";
const RUN_WORKFLOW_BUTTON_FEATURE = "run_workflow_button_feature";
const WorkflowActions = ({ workflow, onWorkflowRun }) => {
  const sendTelemetry = useSendTelemetry();
  const [showEditModal, setShowEditModal] = useState(false);
  const isRunButtonEnabled = useFeature(RUN_WORKFLOW_BUTTON_FEATURE);
  const openEditModal = (event) => {
    event.stopPropagation();
    sendTelemetry(TELEMETRY_EVENT_TYPE.AI_AGENT_WORKFLOW.WORKFLOW_CONFIGURATION_EDIT_OPENED, {
      app_section: "aiagent-workflows",
      event_details: { workflow_type: workflow.id }
    });
    setShowEditModal(true);
  };
  const closeEditModal = () => setShowEditModal(false);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, isRunButtonEnabled && /* @__PURE__ */ React.createElement(RunWorkflowButton, { workflow, onSuccess: onWorkflowRun }), /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", onClick: openEditModal }, "Edit Configuration"), showEditModal && /* @__PURE__ */ React.createElement(EditWorkflowConfigurationModal, { workflow, onClose: closeEditModal }));
};
const AgentWorkflowDetailsPage = () => {
  const { id } = useParams();
  const { data: workflow, isLoading, isError, error, refetch } = useWorkflowDefinition(id);
  if (isLoading) {
    return /* @__PURE__ */ React.createElement(DocumentTitle, { title: "View Agent Workflow" }, /* @__PURE__ */ React.createElement(AgentWorkflowPageNavigation, null), /* @__PURE__ */ React.createElement(PageHeader, { title: "View Agent Workflow" }, /* @__PURE__ */ React.createElement(Spinner, { text: "Loading workflow..." })));
  }
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: workflow ? `View "${workflow.title}" Agent Workflow` : "View Agent Workflow" }, /* @__PURE__ */ React.createElement(AgentWorkflowPageNavigation, null), /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: workflow ? `View "${workflow.title}" Agent Workflow` : "View Agent Workflow",
      actions: workflow ? /* @__PURE__ */ React.createElement(ButtonToolbar, null, /* @__PURE__ */ React.createElement(WorkflowActions, { workflow, onWorkflowRun: refetch })) : null
    },
    /* @__PURE__ */ React.createElement("span", null, "Registered agent workflow configuration and execution status.")
  ), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(ModelProviderRequiredAlert, null), isError && /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger", title: "Failed to load workflow" }, error instanceof Error ? error.message : "Unknown error"), !isError && workflow && /* @__PURE__ */ React.createElement(AgentWorkflowDetails, { workflow }))));
};
export default AgentWorkflowDetailsPage;
